import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const WaitlistForm = ({ variant = "inline", testIdPrefix = "waitlist" }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/waitlist", { email, name });
      setDone(true);
      toast.success("You're on the list. We'll be in touch when new litters are ready.");
    } catch {
      toast.error("Could not save. Try again?");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="border border-border bg-muted px-5 py-4 text-sm text-foreground/85" data-testid={`${testIdPrefix}-success`}>
        Thanks{name && `, ${name}`}! You're on our litter waitlist.
      </div>
    );
  }

  if (variant === "stacked") {
    return (
      <form onSubmit={submit} className="space-y-3" data-testid={`${testIdPrefix}-form`}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name (optional)"
          data-testid={`${testIdPrefix}-name`}
          className="w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta"
        />
        <input
          required type="email" value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid={`${testIdPrefix}-email`}
          className="w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta"
        />
        <button disabled={busy} data-testid={`${testIdPrefix}-submit`} className="w-full rounded-full bg-terracotta px-6 py-3 text-sm text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60">
          {busy ? "Joining…" : "Join the Litter Waitlist"}
        </button>
      </form>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row" data-testid={`${testIdPrefix}-form`}>
      <input
        required type="email" value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`${testIdPrefix}-email`}
        className="flex-1 border border-border bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta"
      />
      <button disabled={busy} data-testid={`${testIdPrefix}-submit`} className="rounded-full bg-terracotta px-6 py-3 text-sm text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60">
        {busy ? "Joining…" : "Join Waitlist"}
      </button>
    </form>
  );
};
